<template>
    <p>{{ $t('guide.guide_popover_step_5_desc') }}</p>
    <pt-button
        color="lightblue"
        :type="props.step.done ? 'outline' : 'contain'"
        @click="handleClick"
    >
        {{ $t('guide.guide_popover_step_5_btn_visit') }}
    </pt-button>
</template>

<script lang="ts" setup>
import useEventBus from '@assets/plugins/eventBus';
import { useProfileInfo } from '@models/profile/useCurrentProfile';
import { GuideStep } from '@master/store/guide.store';

interface Props {
    step: GuideStep;
}

const props = defineProps<Props>();

const { eventBus } = useEventBus();
const { profileInfo } = useProfileInfo();
const emit = defineEmits(['hide', 'trackEvent']);

function handleClick() {
    const currentUrl = window.location.href;
    const sid = profileInfo.value?.sid; // 替换为你的新的 ID
    const baseUrl = currentUrl.split(sid as string)[0];
    const newUrl = baseUrl + sid + '/insight/datacenter/overview';

    emit('hide');
    emit('trackEvent', 'guide_dc_click', { has_completed: props.step.done ? 1 : 0 });
    eventBus.$emit('hideVerifyDialog');
    eventBus.$emit('hideSetup');

    if (currentUrl !== newUrl) {
        eventBus.$emit('goToDataCenter');
    }
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
</style>
